module.exports = __webpack_public_path__ + "df748d96df85809a15067273c985502a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SZ.svg
// module id = 4hf8
// module chunks = 0